import { z } from 'zod';

export const EDLINK_SSO_ISS = 'https://ed.link/api/authentication/oidc';

// Firebase requires custom OIDC providers to be prefixed with "oidc.".
export const EDLINK_FIREBASE_PROVIDER_ID = 'oidc.edlink';

export interface ThirdPartyInitiationParams {
  iss: string;
  client_id: string;
  login_hint: string;
}

export const thirdPartyInitiationParamsSchema = z.object({
  iss: z.string().min(1),
  client_id: z.string().min(1),
  login_hint: z.string().min(1),
});

export function isInitiationComplete(
  params: Partial<ThirdPartyInitiationParams>,
): params is ThirdPartyInitiationParams {
  return thirdPartyInitiationParamsSchema.safeParse(params).success;
}

export function initiationParamsFromUrl(url: URL): Partial<ThirdPartyInitiationParams> {
  const params = new URLSearchParams(url.search);

  return {
    iss: params.get('iss') ?? undefined,
    client_id: params.get('client_id') ?? undefined,
    login_hint: params.get('login_hint') ?? undefined,
  };
}

export function readEdlinkInitiationParams(url: URL, expectedClientId: string): { loginHint: string } | undefined {
  const params = initiationParamsFromUrl(url);

  if (params.iss !== EDLINK_SSO_ISS) {
    return undefined;
  }

  if (!isInitiationComplete(params)) {
    return undefined;
  }

  if (params.client_id !== expectedClientId) {
    return undefined;
  }

  return { loginHint: params.login_hint };
}

export function stripEdlinkInitiationParams(href: string): string {
  const url = new URL(href);
  url.searchParams.delete('iss');
  url.searchParams.delete('client_id');
  url.searchParams.delete('login_hint');
  return url.toString();
}
